<template>
    <div class="home">
        <!-- banner -->
        <div class="bannner">
            <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'" autoplay>
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                    <img
                        :src="item.image"
                        style="width:100%;height:inherit"
                        @click="goNewPath(item)"
                    />
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- 公告 -->
        <div class="container notice">
            <div class="noticeIcon"></div>
            <div class="mainBody" v-if="webBaseInfo.notice">
                <marquee>{{ webBaseInfo.notice }}</marquee>
            </div>
        </div>

        <div class="container brand">
            <div class="items">
                <div
                    class="item"
                    v-for="(item, index) in brandList"
                    :key="index"
                    v-show="item.images"
                >
                    <img :src="item.images" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/common';
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {
            bannerList: [],
            specialProducts: [],
            promotionProducts: [],
            scrollTop: 0,

            // 工具/耗材
            activeGongju: 'first',
            gongjuList: [],
            gongjuListrank: [],

            activeName: 'first',

            brandList: [],

            bannerHeight: 0,
            screenWidth: 0,
        };
    },
    computed: {
        ...mapGetters(['webBaseInfo']),
    },
    methods: {
        goNewPath(item) {
            if (item.link) {
                window.open(item.link);
            }
        },
        getBannerList() {
            apis.queryBannerSimpleList().then(res => {
                this.bannerList = res.data;
            });
        },
        getBrandList() {
            apis.getBrandList({}).then(res => (this.brandList = res.data));
        },
        goPdDetail(val) {
            this.$router.push({ path: '/product-detail/' + val });
        },
        onScroll() {
            window.addEventListener('scroll', () => {
                const scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                this.scrollTop = scrollTop;
            });
        },
        getRankList() {
            apis.goodsListByCategory({
                categoryId: 5,
                categoryIds: '1,2,3,4',
                goodsType: 2,
                rankState: 1,
                recommendState: 1,
            }).then(res => {
                this.gongjuListrank = res.data;
            });
        },
        getGongjuList() {},
    },
    mounted() {
        this.onScroll();

        // 工具、耗材
        // this.getGongjuList();
        // this.getRankList();
        this.getBannerList();
        this.getBrandList();

        // 首次加载时,初始化高度
        this.screenWidth = window.innerWidth;
        this.bannerHeight = (600 / 1550) * this.screenWidth;
        // 窗口大小发生改变
        window.onresize = () => {
            this.screenWidth = window.innerWidth;
            this.bannerHeight = (600 / 1550) * this.screenWidth;
        };
    },
};
</script>
<style lang="less">
.secondItem {
    .el-tabs__nav {
        width: 100%;
        .el-tabs__item {
            width: 20%;
            text-align: center;
            padding: 0;
        }
    }
}
</style>
<style lang="less" scoped>
p {
    margin: 0;
}

.search {
    height: 90px;
    position: relative;
}

.search .logo {
    position: absolute;
    top: 15px;
    left: 0px;
    height: 60px;
    width: 200px;
    background: url(../assets/logo.png) no-repeat;
    background-size: 100%;
}

.searchInput {
    outline: none;
    border: 0;
    width: 600px;
    height: 40px;
    position: absolute;
    top: 25px;
    right: 120px;
    padding: 0 60px 0 10px;
    border-radius: 8px;
}

.searchIcon {
    position: absolute;
    top: 25px;
    right: 120px;
    width: 40px;
    height: 40px;
    background: url(../assets/searchIcon.png) no-repeat center;
}

.structButton {
    position: absolute;
    top: 25px;
    right: 0px;
    width: 100px;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background-color: #3c9539;
    border-radius: 8px;
    border: 0;
}

.bannner {
    width: 100%;
}

@media only screen and (max-width: 1200px) {
    .bannner {
        width: 1200px;
    }
}

.notice {
    margin-top: 20px;
    height: 40px;
    line-height: 46px;
    display: flex;
    background: #ffffff;
    font-size: 14px;
    color: #a2a7b7;
    .noticeIcon {
        width: 40px;
        background: url('../assets/notic.png') no-repeat;
        background-position: 100% 50%;
    }
    .mainBody {
        flex: 1;
        padding: 0 10px;
    }
    .date {
        width: 100px;
    }
}

.brand {
    margin-top: 20px;
    // height: 146px;
    .items {
        width: 1205px;
        display: flex;
        flex-wrap: wrap;
        .item {
            width: 164px;
            height: 76px;
            margin: 0 8px 8px 0;
            border-radius: 10px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                border: none;
            }
        }
    }
}
</style>
